import {
    Container,
    Box,
    Typography,
    Card,
    CardContent,
    Button as MatButton,
    Grid2,
    List,
    ListItem,
    ListItemText,
    Chip,
    FormControl,
    InputAdornment,
    IconButton,
    Input,
    Divider,
    TablePagination,
    Tooltip,
    Badge,
} from "@mui/material";
import AdminHeader from "../../../layouts/AdminLayout/components/AdminHeader/AdminHeader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getUser } from "../../../utils/types";
import { useEffect, useState } from "react";
import API from "../../../api/axios";
import moment from "moment";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DataLoader from "../../../shared/DataLoader/DataLoader";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../components/Button/Button";
import ReplayIcon from '@mui/icons-material/Replay';
import DataNotFound from "../../../shared/DataNotFound/DataNotFound";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Search from "../../../components/Search/Search";
import { useDispatch, useSelector } from "react-redux";
import { toggleDialogTrigger } from "../../../store/slices/notificationSlice";
import { RootState } from "../../../store";
import PageWrapper from "../../../shared/PageWrapper/PageWrapper";

interface NotificationCategory {
    id: number;
    name: string;
}

  interface Notification {
    date_created: string;
    date_updated: string | null;
    id: number;
    is_read: boolean;
    message: string;
    recipient_id: string;
    status: string;
    subject: string;
    user_created: string | null;
    user_updated: string | null;
    view_link: string | null;
    tbl_pk_id: number | null;
    notification_cat_id: { id: number; name: string; };
}
const NotificationListing = () => {
    const [notificationData, setNotificationData] = useState<Notification[]>([]);
    const [recipientid, setRecipientid] = useState()
    const [offset, setOffset] = useState<number>(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [roleCode, setRoleCode] = useState<any>()
    const [notificationTypes,setNotificationTypes] = useState<any>([])
    const [value, setValue] = useState("");
    const [unreadNotificationCount,setUnreadNotificationCount] = useState<any>([])
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // console.log(notificationTypes?.[0]?.id.toString(),"notificationTypes");
    // console.log(typeof notificationTypes?.[0]?.id.toString(),"typeof notificationTypes");  

    useEffect(() => {
        if (notificationTypes.length > 0) {
          setValue(notificationTypes[0].id.toString());
        }
      }, [notificationTypes]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

useEffect(()=>{
    const data = getUser();
    setRecipientid(data?.user?.id);

    let role = data?.roles?.role_code;
    if (role !== "administrator" && role !== "interviewer" && role !== "candidate" && role !== "bidder") {
        role = "talent_admin";
    }
    setRoleCode(role);
    },[])

     useEffect(()=>{
        if(roleCode){
            getMasterNotification()
        }
        },[roleCode])

    const getMasterNotification = async () : Promise<void> =>{
        try{
            const masterNotificationResponse = await API.get("/items/master_generals?fields=id,type,name,target_users&filter[type]=notification_category&filter[status]=published&sort[]=sort&limit=-1");
           
            const formattedNotifications = masterNotificationResponse?.data?.data.filter((item:any) => item.target_users.includes(roleCode)).map((item:any) => ({ id: item.id, name: item.name }));
          
            setNotificationTypes(formattedNotifications)
            // console.log(formattedNotifications, "setNotificationTypes");
        }catch(err){
            // Failed to fetch notification master
        }
    }

    const getNotificationsUnreadCount = async (): Promise<void> => {
        try {
            const response = await API.get(`/items/system_notifications?aggregate[count]=*&filter[recipient_id]=${recipientid}&filter[is_read]=false&filter[status]=published&groupBy=notification_cat_id&offset=0&limit=100&meta=*`);
            
           setUnreadNotificationCount(response?.data?.data);
        } catch (error) {
            // Failed to fetch notifications
        }
    };

    const getNotifications = async (): Promise<void> => {
        try {
            setLoading(true);            
            const response = await API.get("/items/system_notifications", {
                params: {
                    fields: "*,notification_cat_id.id,notification_cat_id.name,notification_cat_id.target_users",
                    "filter[recipient_id]": recipientid,
                    "filter[status]": "published",
                    "sort":"is_read,-date_created",
                    offset: offset,
                    limit: rowsPerPage,
                    meta: "*",
                    "filter[notification_cat_id.id]":value,
                    ...(searchValue && {
                        "filter[_or][0][subject][_icontains]": searchValue,
                        "filter[_or][1][message][_icontains]": searchValue,
                    }),
                },
            })

            setNotificationData(response?.data?.data);
            setTotalRecords(response?.data?.meta?.filter_count);
            
            const isReadFalse = response?.data?.data.filter((data:any)=> !data.is_read);            
            if(isReadFalse.length > 0){
               
                
                const unReadIds = isReadFalse.map((data:any)=> data.id);
                NotificationMarkRead(unReadIds)
            }

        } catch (error) {
            // Failed to fetch notifications
        }finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        if (recipientid && value) {
            getNotifications();
        }
    }, [recipientid, offset, rowsPerPage, searchValue, value]);
   
    const countTrigger = useSelector((state: RootState) => state.notification?.pageTrigger);

     useEffect(() => {
        if (recipientid) {
              getNotificationsUnreadCount(); // Call function when countTrigger changes
        }
          }, [countTrigger]);

    useEffect(() => {
        if (recipientid) {
            getNotificationsUnreadCount();
            dispatch(toggleDialogTrigger()); 
        }
    }, [recipientid, value]);
    
    const NotificationMarkRead = (unreadNotificationsIds:any) =>{
        // console.log(unreadNotificationsIds,"unreadNotificationsIds to make it read");

        if(unreadNotificationsIds?.length > 0) {
            try{
        API.post("/notification/status/update/read",
            {
                "notificationIds": unreadNotificationsIds
            }
        )
        }catch(error){
            // Failed to mark notifications as read
        }
    }
    }

    const handlePageChange = (event: any, newPage: any) => {
        setPage(newPage);
        setOffset(newPage * rowsPerPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (dateString: string): string => {
        return moment(dateString).format('D MMM YYYY');
    };

    useEffect(()=>{
        setPage(0);
        setOffset(0);
    },[value])

    return (
            <PageWrapper>
            <AdminHeader />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",

                }}
            >
                <Typography fontSize={"18px"} color="#000" fontWeight={600}>
                    All Notifications
                </Typography>
                <Button
                    variant="secondary"
                    variantType="contained"
                    label="Back"
                    onClick={() => navigate("/admin/dashboard")}
                />
            </Box>
            <Card
                className="custom__card"
                sx={{
                    marginTop: "1.5rem",
                    backgroundColor: "#fff",
                    minHeight: "60vh"
                }}
            >
                <CardContent sx={{ backgroundColor: "#fff", padding: "0px" }}>
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <Box display={"flex"} justifyContent={"space-between"} sx={{ paddingX: "10px", flexDirection:"column" }}>
                            <Box sx={{ width: "100%", typography: "body1" }}>
                                    <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <TabList
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="tabs"
                                        sx={{
                                            display:"flex",
                                            justifyContent:"space-between",
                                            alignItems:"space-between",
                                            ".MuiTabs-indicator": {
                                                height:"0.2rem",
                                                backgroundColor: "#fb8b0e" ,
                                                },
                                                ".MuiButtonBase-root.Mui-selected": {
                                                backgroundColor: "#ffffff",
                                                color: "#fb8b0e",
                                                border: 0,
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                },
                                            ".MuiButtonBase-root": {
                                            borderRadius: "8px 8px 0px 0px !important",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            },
                                            color: 'grey',
                                        }}
                                        > 
                                        {/* Each tab head  */}
                                        {value &&
                                       notificationTypes?.map((notificationType:any,index:any)=>(
                                                <Tab 
                                                sx={{ overflow: 'visible' }}
                                           label={
                                               <Badge badgeContent={
                                                (() => {
                                                    const matchingNotification = unreadNotificationCount.find((count: any) =>
                                                        count?.notification_cat_id === notificationType?.id
                                                    );
                                                    return matchingNotification?.count || 0;
                                                })()
                                            } color="secondary"
                                               sx={{
                                                   overflow:'visible',
                                                   '& .MuiBadge-badge': {
                                                   top: -4,  
                                                   right: -6, 
                                                   }
                                               }}
                                               >
                                               <span>{notificationType?.name}</span>
                                               </Badge>
                                           } 
                                             value={`${notificationType?.id}`} 
                                           />
                                            ))}
                                        </TabList>
                                       
                                        <Box sx={{display:"flex", flexDirection:"row",alignItems:"center", gap:2}} >
                                        <Box sx={{width:{xs:"8rem", sm:"13rem",md:"18rem"}}}>
                                                <Search
                                                label="Search"
                                                border
                                                onSearch={(val) => {
                                                setSearchValue(val);
                                                }}
                                            />
                                        </Box>
                                </Box>
                                    </Box>
                                    {/* {tabIndexs.map((tabIndex: any, index: number )=>( */}
                                        <TabPanel
                                        value={value}
                                        sx={{
                                        padding: 0,
                                        marginY: "1rem",
                                        }}
                                    >
                            {!!loading ? (
                            <Box sx={{ height: "450px", width: "100%" }}>
                                <DataLoader />{" "}
                            </Box>
                        ) :
                            (<List sx={{ overflow: "auto", width: "100%" }}>
                                {notificationData?.length > 0 ? (
                                    notificationData?.map((notification:any) => (
                                        <Box onClick={() => {
                                            if (notification?.view_link) {
                                                navigate(`/admin${notification?.view_link}`)

                                            }
                                        }}
                                            sx={{ cursor: notification?.view_link ? "pointer" : "default" }}  >
                                            <ListItem
                                                key={notification?.id}
                                                sx={{
                                                    borderBottom: "1px solid #eee",
                                                    backgroundColor: "transparent"
                                                    //  notification?.is_read ? "#FB8B0E12" :"transparent"  
                                                }}
                                            >
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="subtitle2" sx={{ fontSize: "15px", fontWeight: 700 }}>
                                                            {notification?.subject}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <>
                                                            <Typography variant="body2" color="text.primary" sx={{ fontSize: "14px", fontWeight: 400 }}>
                                                                {notification?.message}
                                                            </Typography>
                                                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                                                                <Chip variant="filled" label={formatDate(notification?.date_created)}
                                                                    sx={{
                                                                        marginTop: "7px", borderRadius: "4px", width: "90px", height: "18px", fontSize: "10px", fontWeight: 400,
                                                                    }} />
                                                            </Box>
                                                        </>
                                                    }
                                                />
                                            </ListItem>  
                                            </Box>
                                        ))
                                    ) : (
                                        <Grid2 size={12} sx={{marginTop:"5rem"}}>
                                        <DataNotFound /> 
                                        </Grid2>
                                    )}
                                </List>)}
                                    </TabPanel>
                                {/* ))} */}
                                    </TabContext>
                            </Box>                           
                            </Box>
                        </Grid2>
                        
                       
                        </Grid2>
                    </CardContent>
                </Card>
                {notificationData?.length > 0 && (
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        component="div"
                        count={totalRecords}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                )}
                </PageWrapper> 
    );
};

export default NotificationListing;
